import type { CSSProperties, ReactNode } from 'react'
import { INK, RADIUS_CARD, SHADOW_STICKER } from '../tokens'

interface CardProps {
  children: ReactNode
  style?: CSSProperties
  className?: string
  /** Set false for a card that's purely a layout container with no border/shadow of its own
   * (e.g. a table shell where the table's own rows provide the visual structure). Default true. */
  bordered?: boolean
}

/**
 * The Direction F "sticker" card: white fill, solid ink border, hard drop-shadow.
 * No blur, no transparency -- that's a deliberate departure from the earlier,
 * rejected glassmorphic direction. See /redesignplan.md.
 */
export function Card({ children, style, className, bordered = true }: CardProps) {
  return (
    <div
      className={className}
      style={{
        background: '#fff',
        borderRadius: RADIUS_CARD,
        border: bordered ? `2px solid ${INK}` : 'none',
        boxShadow: bordered ? SHADOW_STICKER : 'none',
        padding: '1.5rem',
        ...style,
      }}
    >
      {children}
    </div>
  )
}
